module.exports = __webpack_public_path__ + "img/logo.3baa444b.png";